import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Silenciar logs en producción
if (environment.production) {
  const noop = () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (console as any).log = noop;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (console as any).debug = noop;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (console as any).info = noop;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (console as any).warn = noop;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (console as any).error = noop;
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
